import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-poll-copy",
  "use": "foquz-icon-poll-copy-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-poll-copy\"><path d=\"M1 8a2 2 0 012-2h4a2 2 0 012 2v4a2 2 0 01-2 2H3a2 2 0 01-2-2V8z\" stroke=\"currentColor\" stroke-width=\"2\" /><path d=\"M8 0a3 3 0 00-3 3v1h2V3a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-1v2h1a3 3 0 003-3V3a3 3 0 00-3-3H8z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol